/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED FROM `elasticsearch/` BY
// `yarn workspace @elastic/esql-definitions generate`.

import type { PromqlFunctionDefinition } from '../../definition_types';

import absDefinition from './abs';
import absentOverTimeDefinition from './absent_over_time';
import acosDefinition from './acos';
import acoshDefinition from './acosh';
import asinDefinition from './asin';
import asinhDefinition from './asinh';
import atanDefinition from './atan';
import atanhDefinition from './atanh';
import avgDefinition from './avg';
import avgOverTimeDefinition from './avg_over_time';
import bottomkDefinition from './bottomk';
import ceilDefinition from './ceil';
import clampDefinition from './clamp';
import clampMaxDefinition from './clamp_max';
import clampMinDefinition from './clamp_min';
import cosDefinition from './cos';
import coshDefinition from './cosh';
import countDefinition from './count';
import countOverTimeDefinition from './count_over_time';
import dayOfMonthDefinition from './day_of_month';
import dayOfWeekDefinition from './day_of_week';
import dayOfYearDefinition from './day_of_year';
import daysInMonthDefinition from './days_in_month';
import degDefinition from './deg';
import deltaDefinition from './delta';
import derivDefinition from './deriv';
import expDefinition from './exp';
import firstOverTimeDefinition from './first_over_time';
import floorDefinition from './floor';
import histogramAvgDefinition from './histogram_avg';
import histogramCountDefinition from './histogram_count';
import histogramFractionDefinition from './histogram_fraction';
import histogramQuantileDefinition from './histogram_quantile';
import histogramSumDefinition from './histogram_sum';
import hourDefinition from './hour';
import ideltaDefinition from './idelta';
import increaseDefinition from './increase';
import irateDefinition from './irate';
import lastOverTimeDefinition from './last_over_time';
import limitkDefinition from './limitk';
import lnDefinition from './ln';
import log10Definition from './log10';
import log2Definition from './log2';
import maxDefinition from './max';
import maxOverTimeDefinition from './max_over_time';
import minDefinition from './min';
import minOverTimeDefinition from './min_over_time';
import minuteDefinition from './minute';
import monthDefinition from './month';
import piDefinition from './pi';
import presentOverTimeDefinition from './present_over_time';
import quantileDefinition from './quantile';
import quantileOverTimeDefinition from './quantile_over_time';
import radDefinition from './rad';
import rateDefinition from './rate';
import roundDefinition from './round';
import scalarDefinition from './scalar';
import sgnDefinition from './sgn';
import sinDefinition from './sin';
import sinhDefinition from './sinh';
import sqrtDefinition from './sqrt';
import stddevDefinition from './stddev';
import stddevOverTimeDefinition from './stddev_over_time';
import stdvarDefinition from './stdvar';
import stdvarOverTimeDefinition from './stdvar_over_time';
import sumDefinition from './sum';
import sumOverTimeDefinition from './sum_over_time';
import tanDefinition from './tan';
import tanhDefinition from './tanh';
import timeDefinition from './time';
import timestampDefinition from './timestamp';
import topkDefinition from './topk';
import vectorDefinition from './vector';
import yearDefinition from './year';

export const promqlFunctionDefinitions: PromqlFunctionDefinition[] = [
  absDefinition,
  absentOverTimeDefinition,
  acosDefinition,
  acoshDefinition,
  asinDefinition,
  asinhDefinition,
  atanDefinition,
  atanhDefinition,
  avgDefinition,
  avgOverTimeDefinition,
  bottomkDefinition,
  ceilDefinition,
  clampDefinition,
  clampMaxDefinition,
  clampMinDefinition,
  cosDefinition,
  coshDefinition,
  countDefinition,
  countOverTimeDefinition,
  dayOfMonthDefinition,
  dayOfWeekDefinition,
  dayOfYearDefinition,
  daysInMonthDefinition,
  degDefinition,
  deltaDefinition,
  derivDefinition,
  expDefinition,
  firstOverTimeDefinition,
  floorDefinition,
  histogramAvgDefinition,
  histogramCountDefinition,
  histogramFractionDefinition,
  histogramQuantileDefinition,
  histogramSumDefinition,
  hourDefinition,
  ideltaDefinition,
  increaseDefinition,
  irateDefinition,
  lastOverTimeDefinition,
  limitkDefinition,
  lnDefinition,
  log10Definition,
  log2Definition,
  maxDefinition,
  maxOverTimeDefinition,
  minDefinition,
  minOverTimeDefinition,
  minuteDefinition,
  monthDefinition,
  piDefinition,
  presentOverTimeDefinition,
  quantileDefinition,
  quantileOverTimeDefinition,
  radDefinition,
  rateDefinition,
  roundDefinition,
  scalarDefinition,
  sgnDefinition,
  sinDefinition,
  sinhDefinition,
  sqrtDefinition,
  stddevDefinition,
  stddevOverTimeDefinition,
  stdvarDefinition,
  stdvarOverTimeDefinition,
  sumDefinition,
  sumOverTimeDefinition,
  tanDefinition,
  tanhDefinition,
  timeDefinition,
  timestampDefinition,
  topkDefinition,
  vectorDefinition,
  yearDefinition,
];
